import React, { Component } from "react";
import { connect } from "react-redux";

import {
  saveCompte,
  updateCompte,
  deleteCompte,
  loadComptes,
} from "../../../store/actions/compteAction";

import TableCompte from "../../../components/TableCompte";
import { Spin } from "antd";

class Comptes extends Component {
  componentDidMount() {
    this.props.loadComptes();
  }

  onChangeType = (e) => {
    this.setState({ type: e.target.value });
  };

  render() {
    const { utilisateur, comptes } = this.props;

    return (
      <Spin size="large" tip="Chargement en cours..." spinning={!comptes}>
        <TableCompte
          utilisateur={utilisateur}
          comptes={comptes}
          saveCompte={this.props.saveCompte}
          updateCompte={this.props.updateCompte}
          deleteCompte={this.props.deleteCompte}
        />
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadComptes: () => dispatch(loadComptes()),
    saveCompte: (compte) => dispatch(saveCompte(compte)),
    updateCompte: (compte, id) => dispatch(updateCompte(compte, id)),
    deleteCompte: (id) => dispatch(deleteCompte(id)),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    comptes: state.comptes.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Comptes);
